<template>
  <div class="solution section3">
    <div class="banner">
      <div class="w1200">
        <h3>现代农业产业园数字化解决方案</h3>
        <p>
          构建现代农业产业园线上+线下混合发展的数字化新模式，
          通过数字平台建设，聚集研发、生产、服务、销售、物流、金融、深加工等产业上下游企业形成具有地方优势、全国特色的线上产业集群，打造“产业CBD”
        </p>
      </div>
    </div>
    <div class="container">
      <div class="section1">
        <img src="@/assets/pc/images/solution/sec5_1_3.jpg" alt />
      </div>
    </div>
    <div class="d_footer1">
      <h3>现代农业产业园建设五大任务</h3>
      <ul class="clear w1200">
        <li>
          <div class="img"></div>
          <p>做大做强主导产业，建设乡村产业兴旺引领区</p>
        </li>
        <li>
          <div class="img"></div>
          <p>促进生产要素集聚，建设现代技术与装备集成区</p>
        </li>
        <li>
          <div class="img"></div>
          <p>推进产加销、贸工农一体化发展，建设一二三产融合发展区</p>
        </li>
        <li>
          <div class="img"></div>
          <p>推进适度规模经营，建设新型经营主体创业创新孵化区</p>
        </li>
        <li>
          <div class="img"></div>
          <p>提升农业质量效益和竞争力，建设高质量发展示范区</p>
        </li>
      </ul>
    </div>

    <div class="d_footer2">
      <h3>现代农业产业园建设的七大内容</h3>
      <ul class="clear w1200">
        <li>
          <div class="img"></div>
          <p>做大做强主导产业</p>
        </li>
        <li>
          <div class="img"></div>
          <p>同步推进一二三产融合</p>
        </li>
        <li>
          <div class="img"></div>
          <p>聚集关键生产要素</p>
        </li>
        <li>
          <div class="img"></div>
          <p>推进绿色循环发展</p>
        </li>
        <li>
          <div class="img"></div>
          <p>推进适度规模经营</p>
        </li>
        <li>
          <div class="img"></div>
          <p>创新完善工作机制</p>
        </li>
        <li>
          <div class="img"></div>
          <p>科学合理规划布局</p>
        </li>
      </ul>
    </div>

    <div class="d_footer3">
      <div class="button" @click="showDialog = true;systemId= '3'">
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <dialog-box
      :showDialog="showDialog"
      :systemId ="systemId"
      @close="showDialog = false"
    ></dialog-box>
  </div>
</template>
<script>
import dialogBox from './components/dialog'
export default {
  components: {
    dialogBox,
  },
  data() {
    return {
      systemId:'3',
      showDialog: false,
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/pc/css/solution-3.scss';
</style>
